import { CantileverLinkButton } from 'components/CantileverButton'
import { AddLinkModal } from 'features/processFlowDiagrams/components/AddLinkModal'
import { ExternalLink } from 'lucide-react'
import type { FC, ReactNode } from 'react'
import { useState } from 'react'
import { SEARCH_PARAM_UNIT_ID } from 'routes/(common_search_params)/-searchParams'
import { SEARCH_PARAM_SITE_ID } from 'routes/(global_search_params)/-searchParams'
import styled from 'styled-components'
import { PfdNode } from 'types'

const NodeContainer = styled.div`
  position: relative;
  display: inline-block;
`

const FloatingLinkButtonContainer = styled.div`
  position: absolute;
  top: -2rem;
  right: -1rem;
  z-index: 10;
`

export const sharedButtonStyles = `
  width: 2rem;
  height: 0.5rem;
  border-radius: 50%;
  transition: all 0.2s ease;
  box-shadow: 0 0.125rem 0.5rem rgba(0, 0, 0, 0.15);

  &:hover {
    opacity: 1;
    transform: scale(1.1);
    box-shadow: 0 0.25rem 0.75rem rgba(0, 0, 0, 0.2);
  }

  &:active {
    transform: scale(0.95);
  }

  svg {
    width: 0.875rem;
    height: 0.875rem;
  }
`

const StyledCantileverLinkButton: typeof CantileverLinkButton = styled(
  CantileverLinkButton
)`
  ${sharedButtonStyles}
`

type BaseNodeWrapperProps = {
  children: ReactNode
  id: string
  siteId: string | undefined
  link?: {
    entryType: string
    entryID: string
    siteID: string
  }
  setNodes: (payload: PfdNode[] | ((nodes: PfdNode[]) => PfdNode[])) => void
}

export const BaseNodeWrapper: FC<BaseNodeWrapperProps> = ({
  children,
  link,
  id,
  siteId,
  setNodes,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false)

  const handleLinkChange = (newLink: {
    entryType: string
    entryID: string
    siteID: string
  }) => {
    setNodes((nodes) =>
      nodes.map((node) =>
        node.id === id
          ? { ...node, data: { ...node.data, link: newLink } }
          : node
      )
    )
  }

  const handleModalClose = () => {
    setIsModalOpen(false)
  }

  return (
    <NodeContainer>
      {children}
      {link && (
        <FloatingLinkButtonContainer>
          <StyledCantileverLinkButton
            to={`/assets/routing`}
            search={{
              [SEARCH_PARAM_SITE_ID]: link.siteID,
              [SEARCH_PARAM_UNIT_ID]: link.entryID,
            }}
            primary
            iconOnly
            title='Open link'
            aria-label='Open link'>
            <ExternalLink />
          </StyledCantileverLinkButton>
        </FloatingLinkButtonContainer>
      )}
      {siteId && (
        <AddLinkModal
          isOpen={isModalOpen}
          onClose={handleModalClose}
          onSave={handleLinkChange}
          siteID={siteId}
        />
      )}
    </NodeContainer>
  )
}
